export default [{
  label: 'Razão social', field: 'razaoSocial', type: 'custom',
},
{ label: 'CNPJ', field: 'cadastroFederal', tdClass: 'col-tamanho-cnpj' },
{ label: 'Situação', field: 'situacao', type: 'custom' }, // reguar ou irregular
{ label: 'Consultado em', field: 'ultimaConsulta' },
{ label: 'Próxima consulta', field: 'proximaConsulta' },
{ label: 'Data da validade', field: 'validade' }]
